<pmv-fieldset [header]="header" *ngIf="header; else nofieldset">
  <ng-container *ngTemplateOutlet="radioButton"></ng-container>
</pmv-fieldset>

<ng-template #nofieldset>
  <ng-container *ngTemplateOutlet="radioButton"></ng-container>
</ng-template>

<ng-template #radioButton>
  <label *ngFor="let option of _options" class="radio-inline">
    <input type="radio" [name]="identifier" [value]="option.value" [(ngModel)]="value" [disabled]="disabled"
    /> {{ option.label }}
  </label>
  <validation [elementBase]="this"></validation>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵy.html